const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo.png`;

const FONT = 'helvetica';

export const PDF_COLORS = {
  brand: [249, 115, 22],
  brandLight: [255, 247, 237],
  brandBorder: [254, 215, 170],
  text: [24, 24, 27],
  textBody: [63, 63, 70],
  textMuted: [113, 113, 122],
  line: [229, 231, 235],
  white: [255, 255, 255],
};

export const PDF_TYPE = {
  brand: { size: 14, style: 'bold', color: PDF_COLORS.brand },
  display: { size: 15, style: 'bold', color: PDF_COLORS.text },
  title: { size: 11, style: 'bold', color: PDF_COLORS.text },
  body: { size: 10, style: 'normal', color: PDF_COLORS.textBody },
  caption: { size: 9, style: 'normal', color: PDF_COLORS.textMuted },
  label: { size: 9, style: 'bold', color: PDF_COLORS.textBody },
  footer: { size: 8, style: 'normal', color: PDF_COLORS.textMuted },
};

export function setPdfType(doc, variant) {
  const type = PDF_TYPE[variant] || PDF_TYPE.body;
  doc.setFont(FONT, type.style);
  doc.setFontSize(type.size);
  doc.setTextColor(...type.color);
}

export function loadReportLogo(maxHeightMm = 14) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        const aspect = img.naturalWidth / img.naturalHeight;
        resolve({
          dataUrl: canvas.toDataURL('image/png'),
          widthMm: maxHeightMm * aspect,
          heightMm: maxHeightMm,
        });
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = LOGO_SRC;
  });
}

export function drawBrandStripe(doc, height = 5) {
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFillColor(...PDF_COLORS.brand);
  doc.rect(0, 0, pageWidth, height, 'F');
}

export function drawSectionBox(doc, x, y, width, height) {
  doc.setFillColor(...PDF_COLORS.brandLight);
  doc.roundedRect(x, y, width, height, 2.5, 2.5, 'F');
  doc.setDrawColor(...PDF_COLORS.brandBorder);
  doc.setLineWidth(0.2);
  doc.roundedRect(x, y, width, height, 2.5, 2.5, 'S');
}

export function drawPageHeader(doc, {
  logo,
  margin = 16,
  headerHeight = 22,
}) {
  const pageWidth = doc.internal.pageSize.getWidth();
  drawBrandStripe(doc, 3);

  const logoY = 8;

  if (logo?.dataUrl) {
    doc.addImage(logo.dataUrl, 'PNG', margin, logoY, logo.widthMm, logo.heightMm);
  } else {
    setPdfType(doc, 'brand');
    doc.text('Enrola', margin, logoY + 5);
  }

  doc.setDrawColor(...PDF_COLORS.line);
  doc.setLineWidth(0.3);
  doc.line(margin, headerHeight, pageWidth - margin, headerHeight);

  return headerHeight + 4;
}

export function drawPageFooter(doc, {
  labels = {},
  printedBy = '',
  pageNumber,
  totalPages,
  margin = 16,
}) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const footerY = pageHeight - 10;

  doc.setDrawColor(...PDF_COLORS.line);
  doc.setLineWidth(0.2);
  doc.line(margin, footerY - 4, pageWidth - margin, footerY - 4);

  setPdfType(doc, 'footer');
  if (printedBy) {
    doc.text(`${labels.printedBy || 'Printed by'}: ${printedBy}`, margin, footerY);
  }

  doc.text('Enrola', pageWidth / 2, footerY, { align: 'center' });
  doc.text(`${pageNumber} / ${totalPages}`, pageWidth - margin, footerY, { align: 'right' });
}

export function wrapTextLines(doc, text, maxWidth) {
  return doc.splitTextToSize(text, maxWidth);
}
